export default "__VITE_ASSET__CboLOyWB__"